import { GridColDef } from "@mui/x-data-grid";
import saveAs from "file-saver";
import ExcelJS from "exceljs";

export const exportDataGridToExcel = async (
  columns: GridColDef[],
  rows: any,
  filename: string = "exported_data",
  sheetName: string = "Data"
): Promise<void> => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  const exportedColumns = columns.filter(
    (col) =>
      col.field !== "delete_action" &&
      col.field !== "actions" &&
      col.field !== "__check__" &&
      col.headerName
  );

  const headers = exportedColumns.map((col) => ({
    header: col.headerName || col.field,
    key: col.field,
    width: (col.width || 100) / 7,
  }));

  worksheet.columns = headers;

  // add Data Rows
  rows.forEach((row: any) => {
    const rowData: { [key: string]: any } = {};
    exportedColumns.forEach((column) => {
      let value = row[column.field];
      rowData[column.field] = value;
    });
    worksheet.addRow(rowData);
  });

  // apply some basic styling to headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" }, // Light grey background
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // generate and Download File
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(blob, `${filename}_${new Date().toLocaleDateString("it-IT")}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    throw new Error("Failed to export data to Excel.");
  }
};
